import { WithInvalidFieldsContext } from 'components/common-form/contexts/WithInvalidFieldsContext';
import { LiveFormContentSkeleton } from 'components/secondaryMarket/live/liveFormContent.skeleton';
import { ModifiedFieldsContext } from 'components/secondaryMarket/shared';
import { SecondaryFormTemplate } from 'components/secondaryMarket/shared/components/SecondaryFormTemplate';
import { TabFatalError } from 'components/secondaryMarket/shared/TabFatalError';
import { SecondaryMarketToolbar } from 'components/secondaryMarket/shared/toolbar/SecondaryMarketToolbar';
import type { SecondaryMarketFormProps } from 'components/Workspaces/SecondaryMarketQuotes/Tabs/shared/Form.connect';
import type { SecondaryMarketKeys, SecondaryMarketKeysPrefix } from 'locales/secondaryMarketKeys';
import type { Form } from 'state/secondaryMarket/shared/form/form.model';

export function LimitOrderForm({
  hasFatalError,
  isLoading,
  bcsProductKey,
  productName,
  traderLabel,
  modifiedFields,
  canResetForm,
  errors,
  sidePanel,
  workspaceType,
  children,
  onResetForm,
  errorKind,
  errorMessage,
  onRetryProductFetch,
}: SecondaryMarketFormProps) {
  if (hasFatalError) {
    if (errorKind === 'Timeout') {
      return <TabFatalError onRetry={onRetryProductFetch} detailsKey="generic.timeout.message" />;
    } else if (errorKind === 'BadRequest') {
      return <TabFatalError details={errorMessage} />;
    }
    return <TabFatalError />;
  }

  return (
    <ModifiedFieldsContext.Provider value={modifiedFields}>
      <WithInvalidFieldsContext<Form, SecondaryMarketKeys, SecondaryMarketKeysPrefix> validationErrors={errors}>
        <SecondaryFormTemplate
          toolbar={
            <SecondaryMarketToolbar
              isLoading={isLoading}
              onResetForm={onResetForm}
              bcsProductKey={bcsProductKey}
              productName={productName}
              traderLabel={traderLabel}
              canResetForm={canResetForm}
              type="limitOrder"
            />
          }
          sidePanel={sidePanel}
          bigSidePanel
        >
          {isLoading ? <LiveFormContentSkeleton workspaceType={workspaceType} /> : children}
        </SecondaryFormTemplate>
      </WithInvalidFieldsContext>
    </ModifiedFieldsContext.Provider>
  );
}
